(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  function initPdpMotion() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var candidates = document.querySelectorAll('[id^="shopify-section-template--"]');
    var sections = [];

    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].querySelector('.product-gallery')) {
        sections.push(candidates[i]);
      }
    }

    if (!sections.length) {
      return;
    }

    sections.forEach(function (section) {
      section.classList.add('pdp-reveal');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pdp-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpMotion);
  } else {
    initPdpMotion();
  }

  } catch(e) { console.error(e); }
})();
})();
